export default Object.freeze({
  otherCompanyId: 0,
  otherBranchId: 0,
  cookieKeyForTransitionalUrl: 'mp-transitional-url',
  cookieKeyForAuthToken: 'mptoken'
})
